export const environment = {
  production: false,
  statusUrl: 'https://develop.alsuper.com',
  rootUrl: 'https://dev.alsuperapi.com',
  rootServicesUrl: 'https://develop.alsuper.com/v1',
  trackingUrl: 'https://trackingqa.alsuper.com',
  siteUrl: 'https://alsuper-dev.alsuperapi.com',
  shopperUrl: 'https://alsuper-shoppers.web.app',
  lambdaUrl: 'https://1xvkw8mish.execute-api.us-west-2.amazonaws.com/dev',
  firebase: {
    apiKey: 'AIzaSyBbw1ydFIh8FdG-ttgPdEfWn1rOEKGNgYQ',
    authDomain: 'alsuper-prod.firebaseapp.com',
    projectId: 'alsuper-prod',
    storageBucket: 'alsuper-prod.appspot.com',
    messagingSenderId: '251054716727',
    appId: '1:251054716727:web:2b791ed75afa09b0684cb2',
    measurementId: 'G-HP8R8L49ST'
  },
  googleMaps: {
    apiKey: 'AIzaSyAnNGcvZNu8UswLje8iaVDxLMPn7ooCyEo'
  },
  paypalSrc: 'https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id=AYK22CA9hegxHcPcMM6FH05hBYGpTrAsGe5Z0uQxCkFkXyFyFSP5UGdhdaOgWWBftLQ8jQXhc2NtH748&vault=true&intent=tokenize&locale=es_MX&currency=MXN',
  fncls: 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99',
  sVarRTAccount: 'AS_B74MSCMT2TXJW_RT',
  sVarACDCCard: 'AS_B74MSCMT2TXJW_PYMNT',
  googleAnalytics: {
    id: 'G-FHVSB6296K',
    url: 'https://www.googletagmanager.com/gtag/js?id='
  },
  profileWhatsapp: 'https://api.whatsapp.com/send?',
  facebookKey: '1046832069412227',
  googleClientID: '251054716727-hbauu5276ar0rd4f75140fg4ku2sg4q0.apps.googleusercontent.com',

  appStore: 'https://apps.apple.com/mx/app/alsuperapp/id1445790957',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.exosfera.alsuper&hl=es_MX',
  version: 'v1.10.3',
  recaptcha: {
    siteKey: '6LcvQOYfAAAAAPQKn9nbJYS2MML-B_4ZCvQSr_En',
  },
  copomex: {
    url: 'https://api.copomex.com/query',
    token: 'pruebas'
  },
  images: 'https://d2e63rjlg57kwc.cloudfront.net',
  pinterestId: '2613797205828',
  defaultStore: '6',
  zendeskConfig: {
    url: 'https://static.zdassets.com/ekr/snippet.js',
    apiKey: 'e7c0a81c-b121-46ac-8c7f-d2f31ebb701a'
  },
  firebaseDocs: {
    order: 'orders'
  }
};
